import styled from '@emotion/styled';

export const FormFieldErrorMessage = styled.div`
    display: block;

    span {
        display: inline-block !important;
        cursor: pointer;
        text-decoration: underline;
    }
`;
